export const fit = () => {
  let minFontSize = 0;

  // 用来适配rem,根据屏幕大小更改根元素的文字大小
  const getEquipment = () => {
    let dom = document.documentElement;
    let { clientWidth = 1200 } = dom;
    if (clientWidth < 1200) clientWidth = 1200; // 用来限制最低宽度为1200
    let fontSize = clientWidth / 100;
    let px = fontSize < minFontSize ? minFontSize : fontSize;
    // 1rem = px;
    dom.setAttribute('style', `font-size: ${px}px`)
  };

  // 获取浏览器文字最小字号
  const getEquipmentFontsize = () => {
    let createDom = document.createElement('div');
    createDom.setAttribute('style', `font-size: 1px;display:none;`);
    let dom = document.documentElement;
    dom.appendChild(createDom);
    let { fontSize = 0 } = getComputedStyle(createDom);
    minFontSize = Number(fontSize.split('px')[0]);
    getEquipment();
  };

  // 执行方法
  getEquipmentFontsize();

  // 监听窗口变化
  window.addEventListener('resize', getEquipment);
};